import moment from 'moment';
import { Link, useLocation } from 'react-router-dom';
import Dropdown from './Dropdown';

const Footer = () => {
    const location = useLocation();

    const handleNavigation = (targetUrl, e) => {
        const currentParams = new URLSearchParams(location.search);

        const [path, search] = targetUrl.split('?');
        const targetParams = new URLSearchParams(search);

        const isSamePath = location.pathname === path;
        const isSameParams =
            Array.from(currentParams.entries()).every(([key, value]) => targetParams.get(key) === value) &&
            Array.from(targetParams.entries()).every(([key, value]) => currentParams.get(key) === value);

        if (isSamePath && isSameParams) {
            e.preventDefault();
            window.location.reload();
        }
    };

    return (
        <div id="footer">
            <div className="container">
                <div className="menu">
                    <ul>
                        <li>
                            <Link to="/pahag010" onClick={(e) => handleNavigation('/pahag010', e)}>
                                사이트 소개
                            </Link>
                        </li>
                        <li>
                            <Link to="/pahah010?tab=1" onClick={(e) => handleNavigation('/pahah010?tab=1', e)}>
                                회원약관
                            </Link>
                        </li>
                        <li>
                            <Link to="/pahah010?tab=2" onClick={(e) => handleNavigation('/pahah010?tab=2', e)}>
                                개인정보취급방침
                            </Link>
                        </li>
                        <li>
                            <Link to="/pahah010?tab=3" onClick={(e) => handleNavigation('/pahah010?tab=3', e)}>
                                이메일 주소 수집 거부
                            </Link>
                        </li>
                        <li>
                            <Link to="/pahac010" onClick={(e) => handleNavigation('/pahac010', e)}>
                                이용안내
                            </Link>
                        </li>
                        <li>
                            <Link to="/pahaa010" onClick={(e) => handleNavigation('/pahaa010', e)}>
                                고객센터
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="info">
                    <ul className="info-company">
                        <li>(주)신흥 04510 서울시 중구 청파로 450 (중림동)</li>
                        <li>대표 문현기</li>
                        <li>사업자등록번호 114-81-43063</li>
                        <li>통신판매업신고 제2012-서울중구-0983호</li>
                        <li>직업정보제공사업신고 서울청 제 2018-11호</li>
                    </ul>
                    <ul className="info-contact">
                        <li>
                            <a href="mailto:admin@dentaljob.co.kr">E-mail : admin@dentaljob.co.kr</a>
                        </li>
                        <li>
                            <a href="tel:0808011580">Tel. 080-801-1580</a>
                        </li>
                        <li>본 사이트의 컨텐츠는 저작권법의 보호를 받는 바, 무단전재, 복사, 배포 등을 금합니다.</li>
                    </ul>
                    <ul className="copyright">
                        <li>
                            {/* COPYRIGHT ⓒ <p>{moment().format('yyyy')}</p> (주)신흥 ALL RIGHT RESERVED. */}
                            COPYRIGHT ⓒ <p>2026</p> (주)신흥 ALL RIGHT RESERVED.
                        </li>
                    </ul>
                </div>
                <div className="collab">
                    <img src="./images/logo-collab.gif" alt="Logo collab" />
                    <Dropdown
                        placeholder="패밀리사이트"
                        className={'open-upwards'}
                        options={[
                            { value: 'http://www.dentalvitamin.com/', option: '덴탈 비타민' },
                            { value: 'https://www.DVmall.co.kr/', option: 'DVmall' },
                            { value: 'https://www.dentalseminar.co.kr/', option: '덴탈 세미나' },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};

export default Footer;
